import { render, staticRenderFns } from "./inquiryAlert.vue?vue&type=template&id=7c453448&scoped=true&"
import script from "./inquiryAlert.vue?vue&type=script&lang=js&"
export * from "./inquiryAlert.vue?vue&type=script&lang=js&"
import style0 from "./inquiryAlert.vue?vue&type=style&index=0&id=7c453448&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c453448",
  null
  
)

export default component.exports